module.exports = __webpack_public_path__ + "img/third_eye.9daa81fc.png";